var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShBlade',{attrs:{"visible":_vm.visible},on:{"update:visible":_vm.closeProfileMenu}},[_c('div',{staticClass:"profileMenu__body"},[_c('settings-nav')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }